export default __webpack_public_path__ + "static/media/33.af1b764c.jpg";